import { Button } from "@material-ui/core";
import React, { useState } from "react";
import SimpleArtist from "../../../../../../../common/types/artist/simple-artist";
import { verifyArtist } from "../../../../sdk/artists";

interface ArtistVerificationProps {
  artist: SimpleArtist;
}

export const ArtistVerificationDialog: React.FC<ArtistVerificationProps> = ({
  artist,
}) => {
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);

  React.useEffect(() => {
    if (artist?.isVerified) {
      setVerified(true);
    }
  }, [artist]);

  const onVerify = () => {
    setLoading(true);
    verifyArtist(artist.id)
      .then(() => {
        setVerified(true);
      })
      .finally(() => setLoading(false));
  };

  return (
    <React.Fragment>
      <Button
        style={{ backgroundColor: verified ? "green" : "grey" }}
        variant="contained"
        onClick={() => onVerify()}
        disabled={verified || loading}
      >
        {verified ? "Verified" : "Verify"}
      </Button>
    </React.Fragment>
  );
};
